import { Organisation, Event, EventDivision, Division, FormatDefinition } from "graphql/generated/types";

export interface RecentlyViewedEvent extends Pick<Event, "id" | "name" | "status" | "date" | "daysWindow"> {
    type: "event",
    organisation: Pick<Organisation, "name" | "logo" | "sportType">
}

export interface RecentlyViewedEventDivision extends Pick<EventDivision, "id" | "eventDivisionId" | "entryCount"> {
    type: "division"
    division: Pick<Division, "name">
    event: Pick<Event, "id" | "name">
    formatDefinition: Pick<FormatDefinition, "isTeams">
}

export type RecentlyViewedItem = RecentlyViewedEvent | RecentlyViewedEventDivision

interface UseRecentlyViewedResult {
    items: RecentlyViewedItem[]
}

export const useRecentlyViewed = (): UseRecentlyViewedResult  => {
    try {
        const items = JSON.parse(window.localStorage.getItem("recentlyViewed") || "[]");
        return { items };
    } catch (error) {
        console.warn("Error parsing recently viewed items from localStorage", error);
        return { items: [] };
    }
};
